<div class="point-links">
    <div class="point-links__form">
        <div class="point-links__form__idelibe d-flex flex-row  gap-4 px-1 align-items-end mb-3">
            <div class="point-links__form__idelibe__autocomplete ">
                <div class="d-flex flex-column ">
                    <label for="ids" class="input-label">Délibération à lier*</label>
                    <p-autoComplete [suggestions]="pointIdsSuggestions()" (completeMethod)="onSearchPointIds($event)"
                        [type]="'number'" [forceSelection]="true" [(ngModel)]="selectedPointId" [optionLabel]="'id'"
                        [appendTo]="'body'" [delay]="500" [showClear]="true">
                        <ng-template pTemplate="item" let-item>
                            <div class="d-inline-flex"
                                [pTooltip]="item.objetSynthese.length > 40 ?item.objetSynthese : '' ">
                                <span>
                                    {{item.id}}</span>
                                @if(item.objetSynthese) {
                                <span class="ml-2">
                                    - {{item.objetSynthese.lengh > 40 ?item.objetSynthese :
                                    (item.objetSynthese.substring(0,40) + '...')}}</span>
                                }
                            </div>
                        </ng-template>
                        <ng-template pTemplate="loader">
                            <i-loader></i-loader>
                        </ng-template>
                    </p-autoComplete>
                </div>
            </div>
            <div class="point-links__form__idelibe__relation-type ">
                <div class="d-flex flex-column ">
                    <label for="relation-type" class="input-label">Type de relation*</label>
                    <p-dropdown [style]="{width: '200px'}" [loading]="fetchingPointLinkTypes()"
                        [disabled]="fetchingPointLinkTypes()" [options]="pointLinkTypesOptions()"
                        [(ngModel)]="selectedPointLinkType" [optionLabel]="'description'"></p-dropdown>
                </div>
            </div>
            <div class="ms-auto">
                <span>
                    <i-button [styleClass]="'green'" [text]="'Ajouter le lien'" [icon]="'bi bi-check-circle-fill'"
                        [disabled]="!canCreatePointLink()" [loading]="creatingPointLink()"
                        (click)="createPointLink()"></i-button>
                </span>
            </div>
        </div>
        @if(hasAccessToICourrier){
        <div class="point-links__form__idelibe d-flex flex-row  gap-4 px-1 align-items-end">
            <div class="point-links__form__idelibe__autocomplete">
                <div class="d-flex flex-column">
                    <label for="ids" class="input-label">Courrier à lier*</label>
                    <p-autoComplete [suggestions]="mailIdsSuggestions()" (completeMethod)="onSearchMailIds($event)"
                        [forceSelection]="true" [(ngModel)]="selectedMailId" [optionLabel]="'id'" [appendTo]="'body'"
                        [delay]="500" [showClear]="true" [type]="'number'">
                        <ng-template pTemplate="item" let-item>
                            <div class="d-inline-flex"
                                [pTooltip]="item.objetSynthese.length > 40 ?item.objetSynthese : '' ">
                                <span>{{item.id}}</span>
                                @if(item.objetSynthese) {
                                <span class="ml-2">
                                    - {{item.objetSynthese.lengh > 40 ?item.objetSynthese :
                                    (item.objetSynthese.substring(0,40) + '...')}}</span>
                                }
                            </div>
                        </ng-template>
                        <ng-template pTemplate="loader">
                            <i-loader></i-loader>
                        </ng-template>
                    </p-autoComplete>
                </div>
            </div>

            <div class="point-links__form__idelibe__relation-type ">
                <div class="d-flex flex-column ">
                    <label for="relation-type" class="input-label">Type de relation*</label>
                    <span>Courrier</span>
                </div>
            </div>
            <div class="ms-auto">
                <span>
                    <i-button [styleClass]="'green'" [text]="'Ajouter le lien'" [icon]="'bi bi-check-circle-fill'"
                        [disabled]="!canCreatePointLinkWithMail()" [loading]="creatingPointLinkWithMail()"
                        (click)="createPointLinkWithMail()"></i-button>
                </span>
            </div>
        </div>
        }
    </div>

    <div class="point-links__lists">
        <div class="point-links__lists__idelibe ">
            <h4 class="point-links__lists__idelibe__title">
                <img src="assets/img/iDelibe.svg" alt="Logo iDélibé" class="me-2" style="height: 24px;" />
                <span>iDélibé</span>
            </h4>
            <div class="point-links__lists__idelibe__list">
                <p-table [value]="pointLinks()" [loading]="fetchingPointLinks() || deletingPointLink()"
                    [selectionMode]="'single'">
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="3">Aucun point lié</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 10%;">ID du point</th>
                            <th style="width: 70%;">Objet</th>
                            <th style="width: 15%;">Type de relation</th>
                            <th style="width: 5%;">
                                <i class="bi bi-gear-wide"></i>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-point>
                        <tr class="cursor-pointer" (click)="openPointPage(point)">
                            <td>
                                <span class="idPoint">{{point.linkPoint.id === point.id ? point.point.id
                                    :point.linkPoint.id }}</span>
                            <td>{{point.linkPoint.objetSynthese}}</td>
                            <td>{{point.typeLiaison}}</td>
                            <td>
                                <span style="color:var(--red-inforius)"
                                    (click)="$event.stopPropagation();onDeleteLink(point)" class="cursor-pointer"
                                    [pTooltip]="'Supprimer le lien avec ce point'" tooltipPosition="left">
                                    <i class="bi bi-trash-fill"></i>
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
        @if(hasAccessToICourrier){
        <div class="point-links__lists__icourrier ">
            <h4 class="point-links__lists__icourrier__title pt-3">
                <img src="assets/img/iCourrier.png" alt="Logo iCourrier" class="me-2" style="height: 24px;" />
                <span>iCourrier</span>
            </h4>
            <div class="point-links__lists__icourrier__list">
                <p-table [value]="pointLinkedMails()" [selectionMode]="'single'"
                    [loading]="fetchingPointLinkedMails() || deletingPointLinkedMail()">
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="3">Aucun courrier lié</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 10%;">ID du courrier</th>
                            <th style="width: 85%;">Objet</th>
                            <th style="width: 5%;">
                                <i class="bi bi-gear-wide"></i>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-linkedMail>
                        <tr class="cursor-pointer" (click)="openMailPage(linkedMail)">
                            <td>
                                <span class="idPoint">{{linkedMail.id}}</span>
                            </td>
                            <td>{{linkedMail.objet}}</td>
                            <td>
                                <span style="color:var(--red-inforius)"
                                    (click)="$event.stopPropagation(); onDeleteLinkedMail(linkedMail)"
                                    class="cursor-pointer" [pTooltip]="'Supprimer le lien avec ce courrier'"
                                    tooltipPosition="left">
                                    <i class="bi bi-trash-fill"></i>
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>

        }
    </div>
</div>